/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_Componente_RDolar_82_36 as Componente_RDolar_82_36,
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_Ro as Ro,
  rec_zo as zo,
} from "../../runtime/index.jsx";
export function IncidenciaEnviada(e) {
  let t = (0, ReactCompiler.c)(19),
    { codigo: n, sinSenal: r, onOtra: i, onVer: a } = e,
    o = r !== void 0 && r,
    s = !o,
    c = o ? `text-(--warning)` : `text-(--success)`,
    l;
  t[0] !== s || t[1] !== c
    ? ((l = <Componente_RDolar_82_36 confeti={s} tono={c} />),
      (t[0] = s),
      (t[1] = c),
      (t[2] = l))
    : (l = t[2]);
  let u;
  t[3] === o
    ? (u = t[4])
    : ((u = o ? (
        <div
          className={`flex flex-col gap-1`}
          children={[
            <p
              className={`text-lg font-semibold text-(--text-h)`}
              children={`Guardado en el teléfono`}
            />,
            <p
              className={`text-sm text-(--text)`}
              children={`No hay señal. El reporte, con la foto, sale solo cuando vuelva. No hace falta repetirlo.`}
            />,
          ]}
        />
      ) : (
        <div
          className={`flex flex-col gap-1`}
          children={[
            <p
              className={`text-lg font-semibold text-(--text-h)`}
              children={`¡Reporte enviado! 🎉`}
            />,
            <p
              className={`text-sm text-(--text)`}
              children={`Ya le llegó al área. Te avisamos cuando lo tomen y cuando lo resuelvan.`}
            />,
          ]}
        />
      )),
      (t[3] = o),
      (t[4] = u));
  let d;
  t[5] === n
    ? (d = t[6])
    : ((d = n && (
        <p
          className={`rounded-2xl border border-(--border) px-4 py-2 text-sm text-(--text)`}
          children={[
            `Código `,
            <strong
              className={`font-mono text-base text-(--text-h)`}
              children={n}
            />,
          ]}
        />
      )),
      (t[5] = n),
      (t[6] = d));
  let f;
  t[7] === i
    ? (f = t[8])
    : ((f = (
        <button
          type={`button`}
          onClick={i}
          className={`${Ro} min-h-12 flex-1`}
          children={`Reportar otra`}
        />
      )),
      (t[7] = i),
      (t[8] = f));
  let p;
  t[9] === a
    ? (p = t[10])
    : ((p = (
        <button
          type={`button`}
          onClick={a}
          className={`${zo} min-h-12 flex-1`}
          children={`Ver lo que reporté`}
        />
      )),
      (t[9] = a),
      (t[10] = p));
  let m;
  t[11] !== f || t[12] !== p
    ? ((m = (
        <div
          className={`flex w-full flex-col gap-2 sm:flex-row`}
          children={[f, p]}
        />
      )),
      (t[11] = f),
      (t[12] = p),
      (t[13] = m))
    : (m = t[13]);
  let h;
  return (
    t[14] !== l || t[15] !== u || t[16] !== d || t[17] !== m
      ? ((h = (
          <div
            className={`mx-auto flex w-full max-w-md flex-col items-center gap-4 py-10 text-center animar-entrada`}
            children={[l, u, d, m]}
          />
        )),
        (t[14] = l),
        (t[15] = u),
        (t[16] = d),
        (t[17] = m),
        (t[18] = h))
      : (h = t[18]),
    h
  );
}
